import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';

import { MenuSliderItem } from '../../../../interfaces/menuSliderItem.types';
import { renderWhenTrueOr } from '../../../../utils';
import { PageType } from '../../../../enums/pageType.enum';

import {
  Container,
  Photo,
  PhotoLabelContainer,
  PhotoHeader,
  PhotoDescription,
  PhotoSliderItem,
  ExternalLink,
  ArrowContainer,
  ArrowIcon,
} from './photoSlider.styled';
import { PhotoSliderData } from './photoSlider.types';

export const PhotoSlider: React.FC<PhotoSliderData> = (data: PhotoSliderData) => {
  const { sliderData } = data;
  const slideCounter = sliderData.length;
  const slideDelay = 3000;
  const [activeSlide, setActiveSlide] = useState(0);

  const changeActiveSlide = () => setActiveSlide((activeSlide + 1) % slideCounter);

  useEffect(() => {
      const interval = setInterval(() => changeActiveSlide(), slideDelay);
      return () => clearInterval(interval);
  }, [changeActiveSlide]);

  const renderSliderItems = () => sliderData.map((sliderItem: MenuSliderItem, index: number) => {
    const renderSlideItemWithLink =  renderWhenTrueOr(
      () => renderExternalLink(index, sliderItem),
      () => renderInternalLink(index, sliderItem),
    );

    return renderSlideItemWithLink(sliderItem.targetType === PageType.External);
  });

  const renderSlideItem = (index: number, sliderItem: MenuSliderItem) => (
    <PhotoSliderItem isVisible={index === activeSlide} key={sliderItem.header + sliderItem.description}>
      <Photo src={sliderItem.image?.localFile?.url} alt={sliderItem.image?.alt_text} />
      <PhotoLabelContainer>
        <PhotoHeader>{sliderItem.header}</PhotoHeader>
        <PhotoDescription>{sliderItem.description}</PhotoDescription>
      </PhotoLabelContainer>
    </PhotoSliderItem>
  );

  const renderExternalLink = (index: number, sliderItem: MenuSliderItem) => (
    <ExternalLink
      href={sliderItem.externalPage}
      target='_blank'
      key={sliderItem.externalPage + sliderItem.header}
    >
      {renderSlideItem(index, sliderItem)}
    </ExternalLink>
  );

  const renderInternalLink = (index: number, sliderItem: MenuSliderItem) => (
    <Link to='/' key={sliderItem.description + sliderItem.header}>
      {renderSlideItem(index, sliderItem)}
    </Link>
  );

  return (
    <Container>
      <ArrowContainer>
        <ArrowIcon />
      </ArrowContainer>
      {renderSliderItems()}
    </Container>
  );
}
